import { Base64 } from "js-base64"
import getJamFilledCookie from "./getJamFilledCookie"

export default function getUserIdFromJamFilledCookie(): string | false {
	try {
		const cookie = getJamFilledCookie()
		const userId = Base64.decode(cookie.split(".")[1])
			.replace('{"_id":', "")
			.split('"')[1]
		return userId
	} catch (e) {
		return false
	}
}
